module.exports = __webpack_public_path__ + "static/media/restrict_icon.ff702882.svg";